import StyledComponent from 'styled-components';

import { Colors } from '../../constant';

const HomeContainer = StyledComponent.div`
  .settings-close-btn
  {
    position: 'absolute',
    right: 8px;
    top: 8px;
    color: ${Colors.settings.closeButton.color}
  }
  margin-top: 10px;
`;

export {
  HomeContainer
};